module.exports = __webpack_public_path__ + "static/img/get-ways.4df3ce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/get-ways.png
// module id = 321
// module chunks = 7